import React, { useState } from "react";
import { renderRichText } from "gatsby-source-storyblok"
import * as styles from "./luxurySeason.module.css"

const LuxurySeason = ({ blok }) => {

  const [activeTab, setActiveTab] = useState(0)

  return(
    <section id="season" className="py-10">
      <div className="text-center max-w-[700px] pt-10 px-4 mb-8 mx-auto ">
        <h2 className="text-3xl font-bold mb-8">{blok.title}</h2>
        <div>{blok.description}</div>
      </div>

      <div className="flex flex-wrap">
        <div className="w-full lg:w-1/2 bg-ivory">
          <div className="p-4 md:p-8 xl:pb-44 flex flex-col items-center relative">
          {blok.seasonItems?.map((item, i) => (
            <div key={i} className={activeTab === i ? 'block' : 'hidden'}>
              <img className="w-full h-auto md:w-[700px] md:h-[450px] object-cover block" loading="lazy" src={item.upperImage.filename} alt={item.upperImage.alt} />
              <img className="w-full h-auto md:w-[470px] md:h-[285px] object-cover mt-4 md:mt-8 xl:absolute xl:bottom-8 xl:right-6" loading="lazy" src={item.lowerImage.filename} alt={item.lowerImage.alt} />
            </div>
          ))}
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <div className="p-4 md:p-8 max-w-[800px]">
            <div className="border-b border-b-black">
              <ul className="-mb-px flex items-center gap-4 text-sm font-medium">
                {blok.seasonItems?.map((item, i) => (
                  <li key={i}>
                    <a onClick={() => setActiveTab(i)}
                      className={`inline-flex cursor-pointer items-center gap-2 sm:px-1 md:px-5 py-3 ${
                        activeTab === i ? 'relative text-primary-700 after:absolute after:left-0 after:bottom-0 after:h-1 after:w-full after:bg-blue-700' : ''
                      }`}
                    >
                      <img className="w-4 h-4 md:w-6 md:h-6" loading="lazy" src={item.icon.filename} alt={item.icon.alt}/>{item.season}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="py-8 px-4 relative">
              <img className="hidden md:block w-[304px] h-[112px] absolute left-[-300px] top-0" src="/icons/yellow-arrow-left.svg" alt="Arrow"/>
              {blok.seasonItems?.map((item, i) => (
                <div key={i} className={activeTab === i ? 'block' : 'hidden'}> 
                 <h1 className="text-lg font-serif font-bold underline-yellow">{item.heading}</h1>
                   <div className={`${styles.luxury_season_details}`} dangerouslySetInnerHTML={{ __html: renderRichText(item.details) }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
    </section>
  ) 
}

export default LuxurySeason
